import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './fleet.reducer';

export const FleetDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const fleetEntity = useAppSelector(state => state.fleet.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="fleetDetailsHeading">
          <Translate contentKey="cabmanApp.fleet.detail.title">Fleet</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{fleetEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="cabmanApp.fleet.name">Name</Translate>
            </span>
          </dt>
          <dd>{fleetEntity.name}</dd>
          <dt>
            <Translate contentKey="cabmanApp.fleet.parent">Parent</Translate>
          </dt>
          <dd>{fleetEntity.parent ? fleetEntity.parent.name : ''}</dd>
          <dt>
            <Translate contentKey="cabmanApp.fleet.tenant">Tenant</Translate>
          </dt>
          <dd>{fleetEntity.tenant ? fleetEntity.tenant.name : ''}</dd>
          <dt>
            <Translate contentKey="cabmanApp.fleet.owner">Owner</Translate>
          </dt>
          <dd>{fleetEntity.owner ? fleetEntity.owner.login : ''}</dd>
        </dl>
        <Button tag={Link} to="/fleet" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/fleet/${fleetEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default FleetDetail;
